import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

const DeletePostModal = ({ isOpen, deleting, onClose, onConfirm }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Delete post</h3>
            <p className="text-sm text-gray-500">This action cannot be undone.</p>
          </div>
          <button
            type="button"
            className="rounded-full p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
            onClick={onClose}
            disabled={deleting}
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-6 py-5">
          <div className="flex items-start gap-3 rounded-lg bg-red-50 p-4 text-sm text-red-700">
            <AlertTriangle size={18} className="mt-0.5 flex-shrink-0" />
            <p>Deleting the post will remove it from the network feed and post detail page.</p>
          </div>

          <div className="mt-5 flex items-center justify-end gap-3">
            <button
              type="button"
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              onClick={onClose}
              disabled={deleting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
              onClick={onConfirm}
              disabled={deleting}
            >
              {deleting ? 'Deleting...' : 'Delete post'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePostModal;
